import { ReactNode } from "react";
import { setCommonHeaderTestId } from "./common-header.utils";

interface CommonHeaderProps {
  title: ReactNode;
  description?: string;
  actions?: ReactNode;
  children?: ReactNode;
  testId?: string;
}

export function CommonHeader({
  title,
  description,
  actions,
  children,
  testId,
}: CommonHeaderProps) {
  return (
    <div
      data-testid={testId ?? setCommonHeaderTestId("container")}
      className="space-y-4"
    >
      <div className="flex items-center justify-between">
        <div className="space-y-1">
          {typeof title === "string" ? (
            <h1
              data-testid={setCommonHeaderTestId("title")}
              className="text-3xl font-bold tracking-tight text-balance"
            >
              {title}
            </h1>
          ) : (
            title
          )}
          {description && (
            <p
              data-testid={setCommonHeaderTestId("description")}
              className="mt-2 text-muted-foreground"
            >
              {description}
            </p>
          )}
        </div>
        {actions && (
          <div
            data-testid={setCommonHeaderTestId("actions")}
            className="flex items-center gap-2"
          >
            {actions}
          </div>
        )}
      </div>
      {children}
    </div>
  );
}
